import { render, staticRenderFns } from "./BasicDisplayerFilterable.vue?vue&type=template&id=19cb0628"
import script from "./BasicDisplayerFilterable.vue?vue&type=script&lang=ts"
export * from "./BasicDisplayerFilterable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports